interface Question {
	question: string;
	answers: { label: string; value: string }[];
	progress: number;
}

interface QuestionsType {
	homeOrBusiness: Question;
	homeOwner: Question;
	energyPayment: Question;
	reasonForQuote: Question;
	typeOfEnergy: Question;
	currentProvider: Question;
	currentProviderHome: Question;
	monthlyBusinessCost: Question;
	typeOfCompany: Question;
}
type QuestionKeys = keyof QuestionsType;

export const questions: QuestionsType = {
	homeOrBusiness: {
		question: "What would you like a quote for?",
		answers: [
			{
				label: "Home",
				value: "home",
			},
			{
				label: "Business",
				value: "business",
			},
		],
		progress: 10,
	},
	homeOwner: {
		question: "Are you a home owner?",
		answers: [
			{
				label: "Yes",
				value: "yes",
			},
			{
				label: "No",
				value: "no",
			},
		],
		progress: 90,
	},
	energyPayment: {
		question: "How do you pay for your energy?",
		answers: [
			{
				label: "Monthly Direct Debit",
				value: "direct-debit",
			},
			{
				label: "Pre-paid Meter/Card",
				value: "pre-paid-meter",
			},
			{
				label: "Receipt of Bill",
				value: "receipt-of-bill",
			},
			{
				label: "Other",
				value: "other",
			},
		],
		progress: 60,
	},
	reasonForQuote: {
		question: "Which of these best describes your reason for a quote?",
		answers: [
			{
				label: "Moving Into a New Home",
				value: "moving",
			},
			{
				label: "Recently Moved Home",
				value: "recently-moved",
			},
			{
				label: "My Existing Home",
				value: "existing-home",
			},
		],
		progress: 70,
	},
	typeOfEnergy: {
		question: "What type of energy does you require?",
		answers: [
			{
				label: "Only Gas",
				value: "only-gas",
			},
			{
				label: "Only Electric",
				value: "pre-paid-meter",
			},
			{
				label: "Both Gas and Electric",
				value: "gas-and-electric",
			},
		],
		progress: 40,
	},
	currentProvider: {
		question: "Who is your current business energy provider?",
		answers: [
			{
				label: "British Gas",
				value: "british-gas",
			},
			{
				label: "EDF",
				value: "edf",
			},
			{
				label: "Scottish Power",
				value: "scottish-power",
			},
			{
				label: "N Power",
				value: "n-power",
			},
			{
				label: "EON",
				value: "eon",
			},
			{
				label: "I don't know",
				value: "unknown",
			},
			{
				label: "Other",
				value: "other",
			},
		],
		progress: 60,
	},
	currentProviderHome: {
		question: "Who is your current energy provider?",
		answers: [
			{
				label: "British Gas",
				value: "british-gas",
			},
			{
				label: "OVO energy",
				value: "edf",
			},
			{
				label: "Scottish Power",
				value: "scottish-power",
			},
			{
				label: "EDF",
				value: "n-power",
			},
			{
				label: "EON",
				value: "eon",
			},
			{
				label: "Utility Warehouse",
				value: "utility-warehouse",
			},
			{
				label: "Octopus",
				value: "octopus",
			},
			{
				label: "I don't know",
				value: "unknown",
			},
			{
				label: "Other",
				value: "other",
			},
		],
		progress: 30,
	},
	monthlyBusinessCost: {
		question: "How much is your current monthly bill per month?",
		answers: [
			{
				label: "Under £1000",
				value: "under-£1000",
			},
			{
				label: "£1000-£2500",
				value: "£1000-£2500",
			},
			{
				label: "£2500-£10,000",
				value: "£2500-£10,000",
			},
			{
				label: "£10,000+",
				value: "£10,000+",
			},
		],
		progress: 80,
	},
	typeOfCompany: {
		question: "What type of company are you?",
		answers: [
			{
				label: "LTD",
				value: "LTD",
			},
			{
				label: "PLC",
				value: "PLC",
			},
			{
				label: "Sole Trader",
				value: "sole-trader",
			},
			{
				label: "Charity",
				value: "charity",
			},
			{
				label: "LLC",
				value: "LLC",
			},
			{
				label: "Other",
				value: "other",
			},
		],
		progress: 90,
	},
};

export const questionScenarios: Record<"home" | "business", QuestionKeys[]> = {
	home: [
		"currentProviderHome",
		"typeOfEnergy",
		"energyPayment",
		"reasonForQuote",
		"homeOwner",
	],
	business: [
		"typeOfEnergy",
		"currentProvider",
		"monthlyBusinessCost",
		"typeOfCompany",
	],
};
